import React from "react";
import { createRoot } from 'react-dom/client';
import CollectionFeaturedCard from "../components/CollectionFeaturedCard";

// function to be called on single collection pages

const renderCollectionFeaturedItemCard =()=>{

	const collectionCardContainers = document.getElementsByClassName("js-collection-featured-card");
	
	if (collectionCardContainers) {
		Array.from(collectionCardContainers).forEach(function (card) {
			const root = createRoot(card);
			root.render(<CollectionFeaturedCard {...card.dataset} />);
		});
	}
		
}

export default renderCollectionFeaturedItemCard;